/* 年月日時分コントロール */
import React from 'react';
import DatePickerJp from './DatePickerJp';
import Messages from '../molecules/Messages';
import { hours, minutes } from './../Const';

interface Props {
  id: string;
  customInput?: JSX.Element;
  selected_ymd: Date | null;
  selected_hour: string;
  selected_minute: string;
  help_msg?: string;
  message?: string;
  handleChangeDate: (date: Date) => void;
  handleChangeHour: (hour: string) => void;
  handleChangeMinute: (minute: string) => void;
}

const DateTimePicker: React.FC<Props> = ({
  id,
  customInput,
  selected_ymd,
  selected_hour,
  selected_minute,
  help_msg,
  message,
  handleChangeDate,
  handleChangeHour,
  handleChangeMinute,
}) => {
  return (
    <div className="datetimepicker-wrapper">
      <div>
        <DatePickerJp
          id={id}
          handleChangeDate={(date: Date) => handleChangeDate(date)}
          selected={selected_ymd}
          customInput={customInput}
        />
        <select
          name="時"
          className="search-form-input-small search-form-time"
          value={selected_hour}
          onChange={(event: React.ChangeEvent<HTMLSelectElement>) =>
            handleChangeHour(event?.target.value)
          }
        >
          <option></option>
          {hours?.map((hour, index) => {
            return (
              <option key={index} value={hour}>
                {hour}
              </option>
            );
          })}
        </select>
        <span>:</span>
        <select
          name="分"
          className="search-form-input-small search-form-time"
          value={selected_minute}
          onChange={(event: React.ChangeEvent<HTMLSelectElement>) =>
            handleChangeMinute(event?.target.value)
          }
        >
          <option></option>
          {minutes?.map((minute, index) => {
            return (
              <option key={index} value={minute}>
                {minute}
              </option>
            );
          })}
        </select>
      </div>
      <div>
        <Messages help_msg={help_msg} valid_msg={message} />
      </div>
    </div>
  );
};

export default DateTimePicker;
